// extracted by mini-css-extract-plugin
export var logo = "_c4-2";
export var logoWrapper = "_c4-1";
export var strip = "_c4-0";